<template>
  <div class="route-container">
    <AgGridVue  
      class="app-table ag-theme-alpine"
      :columnDefs="columnDefs"
      :rowData="rowData"
      rowSelection="single"
      @grid-ready="onGridReady"
      @cell-value-changed="onCellValueChanged"
      :sideBar="sideBar"
      :icons="icons"
      :defaultExcelExportParams="defaultExcelExportParams"
    >
    </AgGridVue>
  </div>
</template>

<script>
import ControllingService from "../services/ControllingService";
import GridService from "../services/GridService";
import { createExcelExportParams, formatSurveyInstanceCount } from "@/services/GridExportService";
import EventBus from "../services/EventBus";

import { AgGridVue } from "ag-grid-vue3";
import 'ag-grid-enterprise';
import CurrencyCellRenderer from "./CellRenderer/CurrencyCellRenderer";

import ConfigurationToolPanel from "./ConfigurationToolPanel";
import NumberCellEditor from "./CellEditor/NumberCellEditor";

export default {
  name: "Invoicing",
  components: {
    AgGridVue,
    ConfigurationToolPanel,
    currencyCellRenderer: CurrencyCellRenderer,
    numberCellEditor: NumberCellEditor,
  },
  data() {
    return {
      columnDefs: null,
      gridApi: null,
      gridColumnApi: null,
      icons:{
        cog: "<i class='cog-via-css'/>"
      },
      rowData: null,
      selectedYear: null,
      sideBar: {
        toolPanels: [
          {
            id: 'configuration',
            labelDefault: 'Konfiguration',
            labelKey: 'configuration',
            iconKey: 'cog',
            toolPanel: 'ConfigurationToolPanel',
            toolPanelParams: {
              parentName: this.$options.name,
            },
          },
          {
            id: 'columns',
            labelDefault: 'Spalten',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressColumnFilter: false,
              suppressColumnSelectAll: false,
              suppressColumnExpandAll: false,
            },
          },
          {
            id: 'filters',
            labelDefault: 'Filter',
            labelKey: 'filters',
            iconKey: 'filter',
            toolPanel: 'agFiltersToolPanel',
            toolPanelParams: {
              suppressExpandAll: false,
              suppressFilterSearch: false,
            },
          },
        ],
      },
      defaultExcelExportParams: createExcelExportParams({ SurveyInstanceCount: formatSurveyInstanceCount }),
    }
  },
  beforeMount() {
    this.selectedYear = new Date().getFullYear();
    this.columnDefs = [
      { headerName: "Kunde", field: "ClientName", sortable: true, filter: true, width:200, resizable: true },
      { headerName: "Projekt", field: "ProjectName", sortable: true, filter: true, width:250, resizable: true },
      { headerName: "Unterprojekt", field: "SubProjectName", sortable: true, filter: true, width:150, resizable: true },
      { headerName: "Auftrag", field: "OrderName", sortable: true, filter: true, width:150, resizable: true },
      { headerName: "Kostenstelle", field: "FullCostCenterCode", sortable: true, filter: true, width: 130, resizable: true },
      { headerName: "CL", field: "Consultant", sortable: true, filter: true, width:70, resizable: true },
      { headerName: "PM", field: "ProjectManager", sortable: true, filter: true, width:120, resizable: true },
      { headerName: "Januar", field: "Jan", sortable: true, filter: true, width: 120, resizable: true, type: 'rightAligned', editable: true, cellEditor: 'numberCellEditor', cellRenderer: 'currencyCellRenderer'},
      { headerName: "Februar", field: "Feb", sortable: true, filter: true, width: 120, resizable: true, type: 'rightAligned', editable: true, cellEditor: 'numberCellEditor', cellRenderer: 'currencyCellRenderer'},
      { headerName: "März", field: "Mar", sortable: true, filter: true, width: 120, resizable: true, type: 'rightAligned', editable: true, cellEditor: 'numberCellEditor', cellRenderer: 'currencyCellRenderer'},
      { headerName: "April", field: "Apr", sortable: true, filter: true, width: 120, resizable: true, type: 'rightAligned', editable: true, cellEditor: 'numberCellEditor', cellRenderer: 'currencyCellRenderer'},
      { headerName: "Mai", field: "May", sortable: true, filter: true, width: 120, resizable: true, type: 'rightAligned', editable: true, cellEditor: 'numberCellEditor', cellRenderer: 'currencyCellRenderer'},
      { headerName: "Juni", field: "Jun", sortable: true, filter: true, width: 120, resizable: true, type: 'rightAligned', editable: true, cellEditor: 'numberCellEditor', cellRenderer: 'currencyCellRenderer'},
      { headerName: "Juli", field: "Jul", sortable: true, filter: true, width: 120, resizable: true, type: 'rightAligned', editable: true, cellEditor: 'numberCellEditor', cellRenderer: 'currencyCellRenderer'},
      { headerName: "August", field: "Aug", sortable: true, filter: true, width: 120, resizable: true, type: 'rightAligned', editable: true, cellEditor: 'numberCellEditor', cellRenderer: 'currencyCellRenderer'},
      { headerName: "September", field: "Sep", sortable: true, filter: true, width: 120, resizable: true, type: 'rightAligned', editable: true, cellEditor: 'numberCellEditor', cellRenderer: 'currencyCellRenderer'},
      { headerName: "Oktober", field: "Oct", sortable: true, filter: true, width: 120, resizable: true, type: 'rightAligned', editable: true, cellEditor: 'numberCellEditor', cellRenderer: 'currencyCellRenderer'},
      { headerName: "November", field: "Nov", sortable: true, filter: true, width: 120, resizable: true, type: 'rightAligned', editable: true, cellEditor: 'numberCellEditor', cellRenderer: 'currencyCellRenderer'},
      { headerName: "Dezember", field: "Dec", sortable: true, filter: true, width: 120, resizable: true, type: 'rightAligned', editable: true, cellEditor: 'numberCellEditor', cellRenderer: 'currencyCellRenderer'},
      { headerName: "Summe", field: "Sum", sortable: true, filter: true, width:120, resizable: true, type: 'rightAligned', cellRenderer: 'currencyCellRenderer' },
      { headerName: "Budget exkl. Rückstellungen", field: "BudgetExReserves", sortable: true, filter: true, width:240, resizable: true, type: 'rightAligned', cellRenderer: 'currencyCellRenderer' },
    ];
  },
  mounted() {
    EventBus.on(`${this.$options.name}_newConfig`, params => {
      this.selectedYear = params.selectedYear;
      this.loadRowData();
      GridService.clearFilter(this.gridApi);
    })
  },
  activated() {
    if (this.$route.path == "/invoicing") {
      this.loadRowData();
    }
  },
  methods: {
    loadRowData() {
      if(this.gridApi) this.gridApi.showLoadingOverlay();

      ControllingService.getInvoicing(this.selectedYear)
        .then(res => {
          this.rowData = [];
          if(res.data === '') return;
          this.rowData = res.data;
        })
        .finally(() => {
          if(this.gridApi) this.gridApi.hideOverlay();
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onCellValueChanged(params) {
      var invoicing = {
        "Month": params.column.colId,
        "Year": this.selectedYear,
        "OrderId": params.data.OrderId,
        "InvoicingAmount": params.newValue
      };
      ControllingService.setInvoicing(invoicing)
      .then(res => {
        if(res.status == 200) {
          // Summe neu berechnen
          this.calculateSum(params.data.OrderId);
        }
      })
      .catch(err => {
        console.error(err);
      })
    },
    calculateSum(orderId) {
      let order = this.rowData.find(e => e.OrderId === orderId);
      if(!order) console.error(`cannot calculate sum of order`);

      let sum = 
        Number(order?.Jan) + 
        Number(order?.Feb) + 
        Number(order?.Mar) + 
        Number(order?.Apr) + 
        Number(order?.May) + 
        Number(order?.Jun) + 
        Number(order?.Jul) + 
        Number(order?.Aug) + 
        Number(order?.Sep) + 
        Number(order?.Oct) + 
        Number(order?.Nov) + 
        Number(order?.Dec)
      ;
      order.Sum = sum;

      this.gridApi.refreshCells();
    }
  }
}
</script>

<style>

</style>